<template>
  <div class="contractPage">
    <div class="page-header js-returnShorexBtn">
      <div class="page-header-title">
        <p>注销&退会</p>
        <a class="page-header-returnButton" @click="goBack()">
          <img
            src="https://resource.rcclchina.com.cn/mobileSearchPackage/arrowRightBlack.png"
          />
        </a>
      </div>
    </div>

    <main v-if="pageNumber == 1">
      <div class="content-title">{{ pageTitle }}</div>
      <div :class="['content-page']" v-html="pageData"></div>
      <div class="login-part-terms">
        <span
          class="input__top isAgreePrivacy"
          @click="getPrivacy"
          :class="{ active: showPrivacy }"
        >
          <img
            src="https://resource.rcclchina.com.cn/mobileSearchPackage/guest-selected.png"
          />
          <img
            src="https://resource.rcclchina.com.cn/mobileSearchPackage/guest-noSelected.png"
          />
          <span class="privacyLink external">我已阅读并同意注销或退会告知</span>
        </span>
      </div>

      <div class="next-btn-box">
        <div
          class="next-btn"
          :class="{ disabled: !showPrivacy }"
          @click="onNext"
        >
          下一步
        </div>
      </div>
      <div class="pageFooter"></div>
    </main>
    <main v-else-if="pageNumber == 2">
      <div class="page-title">请选择您需要的操作</div>
      <div class="page-selected-box">
        <div class="log-out-type" @click="cancellationType = 1">
          <img
            v-if="cancellationType == 1"
            src="https://resource.rcclchina.com.cn/mobileSearchPackage/sec-selected.png"
          />
          <img
            v-else
            src="https://resource.rcclchina.com.cn/mobileSearchPackage/sex-noSelected.png"
          />
          <span>用户账户注销</span>
        </div>
        <div
          class="log-out-type"
          v-if="isRegisteredMember"
          @click="cancellationType = 2"
        >
          <img
            v-if="cancellationType == 2"
            src="https://resource.rcclchina.com.cn/mobileSearchPackage/sec-selected.png"
          />
          <img
            v-else
            src="https://resource.rcclchina.com.cn/mobileSearchPackage/sex-noSelected.png"
          />
          <span>退出“皇家游享荟”</span>
        </div> 
      </div>
      <div class="next-btn-box next-btns-box">
        <div class="next-btn grey" @click="nextStep(1)">上一步</div>
        <div class="next-btn" :class="{ disabled: cancellationType == 0 }" @click="cancellationCheck">下一步</div>
      </div>
    </main>
    <main v-else-if="pageNumber == 3">
      <div class="page-text pad-t3">
        <!-- 请确认，您需要注销/退会当前登录的账号，我们将按照注销/退会告知进行处理，一旦您点击确认将无法撤回 --> 
        <div v-if="cancellationType == 1">
          请确认，您当前登录的账号申请用户账号注销，一旦您点击确认，我们将按照《用户账户注销告知》进行处理，包括但不限于会员积分清零，会员等级及所有会员权益终止，所有个人信息删除，无法通过原注册手机号登录我们的数字平台等，并且无法撤回。
        </div>
        <div v-if="cancellationType == 2">
          请确认，您当前登录的账号申请退出”皇家游享荟”，一旦您点击确认，我们将按照《皇家游享荟会员退会告知》进行处理，包括但不限于会员积分清零，会员等级及所有会员权益终止等，并且无法撤回。
        </div>
      </div>
      <div class="page-text">手机号：{{ phone }}</div>
      <div class="next-btn-box next-btns-box">
        <div class="next-btn grey" @click="nextStep(2)">上一步</div>
        <div class="next-btn" @click="cancellationSubmit">确认</div>
      </div>
    </main>
  </div>
</template>

<script>
import api from "@/api";

export default {
  name: "UserAgreement",
  data() {
    return {
      userToken: "",
      pageData: "",
      pageTitle: "",

      showPrivacy: false,
      pageNumber: 1, // 页面类型 1:协议 2:退会注销 3:
      cancellationType: 0, //注销类型: 1-注销 2-退会

      isRegisteredMember: false, // 是否为注册会员

      phone: "",
    };
  },

  beforeMount() {
    this.userToken = this.$store.state.user.userToken;

    this.getIsRegisteredMember();
    this.initPage();
  },
  methods: {
    async getIsRegisteredMember() {
      const { success, data, errMsg } = await api.user.IsRegisteredMemberApi(
        this.userToken,
      );
      if (success && data) {
        this.isRegisteredMember = data; 
      } else {
        console.log(errMsg);
      }
    },
    async initPage() {
      const userToken = this.$store.state.user.userToken;
      if (!userToken && userToken.length == 0) {
        this.$router.push(
          `/Orchard.Rccl.Users/Login/Login?returnUrl=${encodeURIComponent(
            window.location.pathname,
          )}`,
        );
        return;
      }

      const { success, data } = await api.page.getContentByKey({
        key: "MEMBER_CANCELLATION_DESC",
      });
      if (success && data) {
        this.pageData = data.content;
        this.pageTitle = data.title;
      }
    },

    getPrivacy(){
      this.showPrivacy = !this.showPrivacy
    },

    onNext() {  
      if (!this.showPrivacy) { 
          // this.$alert.show("请勾选退会或注销告知");
          return;
        }
      this.pageNumber = 2;
    },
    nextStep(number) { 
      this.pageNumber = number;
    },

    async cancellationCheck() {
      if (this.cancellationType != 1 && this.cancellationType != 2) {
        // this.$alert.show("请勾选退会或注销");
        return;
      } 

      const { success, data, errMsg } = await api.user.cancellationCheck(
        this.userToken,
      );
      if (success && data) {
        if (!data.status) {
          this.$alert.show(data.msg, {
            title: "温馨提示",
            button: "关闭",
          });
          return;
        } else {
          this.phone = data.phone;
          this.pageNumber = 3;
        }
      } else {
        console.log(errMsg);
      }
    },

    // 二次确认提交
    async cancellationSubmit() {
      const { success, errMsg } = await api.user.cancellationSubmit({
        userName: this.userToken,
        cancellationType: this.cancellationType,
        remark: "",
      });
      if (success) {
        let text = "我们会在15天内完成数据清理，在此期间您的账户将被冻结并且无法登录，请确认后再提交。";
        if (this.cancellationType == 2) {
          text = "我们会在15天内完成数据清理，在此期间您的账户将被冻结并且无法登录，请确认后再提交";
        }
        this.$alert.show(text, {
          title: "温馨提示",
          button: "关闭",
          confirmCallBack: () => {
            this.logout();
          },
        });
      } else {
        console.log(errMsg);
      }
    },

    logout() {
      this.$store.commit("REMOVE_USER_TOKEN");
      this.$router.replace('/');
    },

    goBack() {
      this.$router.go(-1);
    },
  },
};
</script>

<style lang="less">
.contractPage {
  background: white;
  padding: 0;

  .page-header {
    position: fixed;
    z-index: 10;
    width: 100%;
    padding-bottom: 10px;
    background-color: #f6f7f8;

    .page-header-title {
      padding: 15px 20px;
      background-color: #fff;
      overflow: hidden;
      text-align: center;
      width: 100%;

      > p {
        font-size: 14px;
        color: #333333;
        letter-spacing: 1px;
        text-align: center;
        margin: 0;
      }
      .page-header-returnButton {
        width: 30px;
        position: absolute;
        top: 15px;
        left: 20px;
        text-align: left;
        > img {
          width: 33%;
        }
      }
    }
  }

  .content-title {
    padding: 3.4rem 0 0.5rem;
    font-size: 0.8rem;
    text-align: center;
  }
  .content-page {
    font-size: 0.8rem;
    // position: absolute;
    // top: 2.2rem;
    // bottom: 0;
    // left: 0;
    // right: 0;
    padding: 0 0.75rem 0.75rem;
    background: white;
    overflow-x: hidden;
    overflow-y: auto;
    &.hide-page-title {
      top: 0;
    }

    .content {
      position: relative;
      top: 0;
      .content-block {
        margin: 0 !important;
        padding: 0 0.75rem 0.75rem !important;
        background: white !important;
      }
    }
    .page {
      background: white !important;
    }

    .pageHeader {
      margin: 10px 0;
    }
    p {
      margin: 10px 0;
    }
    .table {
      width: 100%;
      overflow-x: auto;
      border-collapse: collapse;
      border: 1px solid #ddd;
    }
    .table .th {
      padding: 8px;
      border: 1px solid #ddd;
    }
    .table .td {
      vertical-align: top;
      padding: 8px;
      border: 1px solid #ddd;
    }
    .table .th p,
    .table .td p {
      margin: 0;
    }
    .tableBox .table {
      width: 1200px;
      overflow-x: auto;
      border-collapse: collapse;
    }
    a {
      cursor: pointer;
    }
  }

  .login-part-terms {
    margin-top: 8px;
    padding: 0px 0.75rem;
    text-align: left;
    color: #292b2c;
    line-height: 20px;
    span.input__top {
      display: flex;
      align-items: center;
      img {
        cursor: pointer;
        width: 16px;
        position: relative;
      }
      img:nth-child(1) {
        display: none;
      }
      img:nth-child(2) {
        display: inline-block;
      }
      &.active {
        img:nth-child(1) {
          display: inline-block;
        }
        img:nth-child(2) {
          display: none;
        }
      }
      span {
        margin-left: 8px;
        font-size: 15px;
        font-weight: 400;
        color: rgb(102, 102, 102);
      }
    }
  }

  .next-btn-box {
    padding: 30px 0.75rem 10px;
    .next-btn {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 40px;
      width: 100%;
      color: rgb(69, 69, 69);
      background: linear-gradient(225deg,rgba(255,219,23,1) 0%,rgba(252,191,0,1) 100%) ;
      border-radius: 40px;
    }

    .grey { 
     background: #f0f0f0; 
    }

    .disabled { 
      background: linear-gradient(225deg,rgba(255,219,23,.6) 0%,rgba(252,191,0,.6) 100%) !important;
    }
  }

  .next-btns-box {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 10px;
  }

  .page-title {
    padding: 4rem 0 0;
    font-size: 18px;
    font-weight: 500;
    margin-bottom: 40px;
    text-align: center;
  }

  .page-selected-box {
    padding-left: 30px;
    .log-out-type {
      margin-bottom: 20px;
      display: -webkit-box;
      display: -webkit-flex;
      display: -moz-box;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-align: center;
      -webkit-align-items: center;
      -moz-box-align: center;
      -ms-flex-align: center;
      align-items: center;

      span {
        margin-left: 6px;
        font-size: 14px;
      }

      img {
        width: 14px;
        height: 14px;
      }
    }
  }

  .pad-t3 {
    padding: 4rem 0 0;
  }

  .page-text {
    margin: 0px 0.75rem 20px;
    font-size: 16px;
    text-align: left;
  }
}
.pageFooter {
  height: 45px;
}
</style>
